import "./TabsGreyBtn.scss"

const TabsGreyBtn = ({ title, btns, currentBtn, setCurrentBtn, checkValue = false, returnEvent }) => {

    return (
        <div className='tabs-grey-btn'>
            {title && <p className='text'>{title}</p>}
            <div className='tabs-grey-btn__content'>
                {
                    btns.map((el, ind) => {
                        const { label, value, count } = el
                        return (
                            <button
                                key={label + value}
                                className={checkValue ? currentBtn == value ? 'btn_active' : 'btn' : currentBtn == label ? 'btn_active' : 'btn'}
                                onClick={(e) => {
                                    if (returnEvent) {
                                        setCurrentBtn(el)
                                    }
                                    setCurrentBtn(checkValue ? value : label)
                                }}
                            >{label}
                                {(count || count === 0) && <div className="count">{`${(count || count === 0) ? count : ''}`}</div>}
                            </button>
                        )
                    })
                }
            </div>
        </div>
    )
}

export { TabsGreyBtn }